export const collectionCopy: Readonly<Record<string, string>> = {
  pashmina: 'Soft warmth and graceful drape, with the quiet elegance of pashmina.',
  'wool-and-blends': 'Comforting warmth and versatile textures for everyday layering.',
  'kani-and-embellished': 'Expressive patterns and decorative details that make every look distinctive.',
};
